/* eslint-disable import/no-named-as-default */
import { AlertBox, useDeviceContext } from '@spotahome/ui-library';

import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { ListingShape } from '../../shapes/listing';

import ListingSocialButtons from '../ListingSocialButtons';

import './BookNowCardNotAvailable.scss';

const BookNowCardNotAvailable = ({ listing, deviceType }) => {
  const { deviceOS } = useDeviceContext();
  return (
    <div
      className="booknow-card-not-available"
      data-test="booknow-card-not-available"
    >
      <div className="booknow-card-not-available__title">
        <ListingSocialButtons
          deviceType={deviceType}
          listingId={listing.id}
          deviceOS={deviceOS}
        />
      </div>
      <div className="booknow-card-not-available__body">
        <AlertBox
          message={trans('listing.book-now-not-available.alertbox-message')}
          roundedCorners
        />
      </div>
    </div>
  );
};

BookNowCardNotAvailable.propTypes = {
  listing: PropTypes.shape(ListingShape).isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default BookNowCardNotAvailable;
